module.exports = __webpack_public_path__ + "img/jwt.d447a03d.svg";